import { useState } from 'react'
import ErrorBoundary from './ErrorBoundary'
import ParkDetailView from './ParkDetailView'
import ParksOverview from './ParksOverview'
import Sidebar from './Sidebar'
import { errorDetail, errorMessage } from '../lib/api'
import { useParks } from '../lib/hooks'

/** The signed-in shell: park list on the left, the selected park on the right. */
export default function AdminShell({ onLogout }: { onLogout: () => void }) {
  const [slug, setSlug] = useState<string | null>(null)
  const parks = useParks()
  const list = parks.data ?? []
  const error = parks.isError ? errorMessage(parks.error) : null

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">
          <strong>Recramap beheer</strong>
          <span className="muted small">Plattegronden, plaatsen en koppelingen</span>
        </div>
        <div className="spacer" />
        {parks.isFetching && <span className="muted small">bijwerken…</span>}
        <button type="button" className="btn" onClick={onLogout}>
          Uitloggen
        </button>
      </header>
      <div className="shell">
        <Sidebar parks={list} loading={parks.isPending} error={error} selected={slug} onSelect={setSlug} />
        <main className="main">
          <ErrorBoundary key={slug ?? 'overview'}>
            {slug === null ? (
              <ParksOverview
                parks={list}
                loading={parks.isPending}
                error={error}
                errorDetail={parks.isError ? errorDetail(parks.error) : null}
                onRetry={() => void parks.refetch()}
                onOpen={setSlug}
              />
            ) : (
              <ParkDetailView slug={slug} />
            )}
          </ErrorBoundary>
        </main>
      </div>
    </div>
  )
}
